
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import UserSuspending from './userSuspending';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class ViewUserSuspending extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} suspendUser={true} />,
                id: 0,
            }, {
                title: 'User Status',
                content: <UserSuspending />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default ViewUserSuspending
